<template>
  <div class="flex flex-row w-screen h-screen relative bg-gray-50">
    <BaseSidebar />
    <div class="h-full w-full flex flex-col flex-1 overflow-y-scroll">
      <div class="border-b w-full flex p-4 justify-between">
        <div class="flex gap-x-1">
          <span
            class="flex items-center cursor-pointer text-gray-600 hover:text-gray-900"
            @click="$router.push({ name: 'campaign' })"
          >
            Campaign
          </span>
          <span class="flex items-center text-gray-400">
            <Icon name="ic:baseline-keyboard-arrow-right" />
          </span>
          <span class="flex items-center text-primary-500 font-bold">
            {{ campaign?.name || 'Campaign details' }}
          </span>
        </div>
      </div>

      <div
        v-if="!isLoading"
        class="h-full w-full flex flex-col flex-1 bg-gray-100 overflow-y-auto"
      >
        <div class="p-6 rounded-md contentContainer">
          <slot />
        </div>
      </div>
      <div
        v-else
        class="w-full flex items-center justify-center flex-1"
      >
        <ProgressSpinner />
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
const route = useRoute()

const isLoading = ref(true)
const campaignId = computed(() => route.params?.id?.toString())
const campaign = ref<{ name?: string } | null>(null)
const { getCampaign } = useCampaigns()

onMounted(async () => {
  await loadCampaign()
})

watch(campaignId, async () => {
  await loadCampaign()
})

const loadCampaign = async () => {
  if (!campaignId.value) {
    isLoading.value = false
    return
  }

  isLoading.value = true
  try {
    const res = await getCampaign(campaignId.value)
    campaign.value = res
  }
  catch (error) {
    console.error('Error loading campaign:', error)
  }
  finally {
    isLoading.value = false
  }
}
</script>
